import { apiInstance } from "./networking";
export const form60Upload = async (payload) => {
    const {data = {}} = await apiInstance.post(`customer/form-60-generation`,payload);
    // const {data = {}} = await apiInstance.post(`customer/form-97-generation`,payload);
    return data;
};